module.exports = __webpack_public_path__ + "assets/logo.75b1587a.svg";